import { render } from "./ControlSlider.vue?vue&type=template&id=954f54aa&scoped=true&ts=true&lang=pug"
import script from "./ControlSlider.vue?vue&type=script&lang=ts"
export * from "./ControlSlider.vue?vue&type=script&lang=ts"

import "./ControlSlider.vue?vue&type=style&index=0&id=954f54aa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-954f54aa"]])

export default __exports__